import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 2.60852V14.3485L16.304 19.0435H12.391L9.954 21.3915H6.913V19.0435H3V5.73852L4.227 2.60852H21ZM19.435 4.17352H6.13V15.9135H9.26V18.2605L11.609 15.9125H16.304L19.434 12.7825V4.17352H19.435ZM16.305 7.30352V11.9995H14.739V7.30452H16.304L16.305 7.30352ZM12.391 7.30352V11.9995H10.826V7.30452H12.391V7.30352Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Twitch"
);
